import { render } from "./WCWebAds.vue?vue&type=template&id=e70f8ca0&scoped=true"
import script from "./WCWebAds.vue?vue&type=script&lang=js"
export * from "./WCWebAds.vue?vue&type=script&lang=js"

import "./WCWebAds.vue?vue&type=style&index=0&id=e70f8ca0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e70f8ca0"]])

export default __exports__